<template>
    <div class="container-outline">
        <div class="register">
            <div class="title-page">Register</div>
            <div class="top-squence">
                <head-register :dataSquence="{ id: 12, title: 'kode akses' }"></head-register>
            </div>
            <div class="content-register">
                <div class="container">
                    <div class="wrap-document">
                        <div class="page">
                            <p class="title">PERATURAN PERDAGANGAN (<i>TRADING RULES</i>)</p>
                            <div v-for="platform in dataPlatform" :key="platform.code">
                                <div class="content mb-5" v-if="platform.code == 'BEI05002'">
                                    <h5>Meta Trader 5 ICDX</h5>
                                    <div class="format-text"><label>Trading Rules</label> : <span>Trading Rules Multilateral MT5 ICDX</span></div>
                                    <div class="format-text">
                                        <label>Biaya yang dikenakan setiap pelaksanaan transaksi</label> :
                                        <span>Forex Mini (USD 3 Lot/Side), Forex Micro (USD 1 Lot/Side)</span>
                                    </div>
                                    <div class="penutup">
                                        <div class="content-penutup">
                                            Dengan mengisi kolom “YA” di bawah ini, saya menyatakan bahwa saya telah membaca tentang
                                            <span>PERATURAN PERDAGANGAN (TRADING RULES)</span>, mengerti dan menerima ketentuan dalam bertransaksi
                                        </div>
                                        <div class="pernyataan">
                                            <div class="label">Pernyataan menerima/tidak</div>
                                            <div class="input">
                                                <input
                                                    type="radio"
                                                    name="radios"
                                                    id="1"
                                                    :value="true"
                                                    v-model="statementTrading"
                                                    required
                                                    @click="(openModal = true), (modalTradingRules = 'icdx')"
                                                /><label class="label-radio" for="">Ya</label>

                                                <input type="radio" name="radios" id="2" :value="false" v-model="statementTrading" /><label
                                                    class="label-radio"
                                                    for=""
                                                    >Tidak</label
                                                >
                                            </div>
                                        </div>
                                        <div class="pernyataan">
                                            <div class="label">Menerima Pada Tanggal</div>
                                            <div>
                                                {{ currentDate | formatDateTime }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="self-modal" v-show="openModal">
                                        <div class="content-modal" ref="modal">
                                            <div class="title-modal">
                                                <span class="show-content">PERATURAN PERDAGANGAN (TRADING RULES)</span>
                                                <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="openModal = false">
                                                    <span aria-hidden="true">&times;</span>
                                                </button>
                                            </div>
                                            <div class="body-modal">
                                                <trading-gofx :dataPrint="dataPrint"></trading-gofx>
                                            </div>
                                            <div class="footer-modal">
                                                <div class="btn-primer show-content" @click="openModal = false">Setuju</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="content mt-5" v-if="platform.code == 'BEI05001'">
                                    <h5>Jafets Now JFX</h5>
                                    <div class="format-text"><label>Trading Rules</label> : <span>Trading Rules Multilateral Jafets Now JFX</span></div>
                                    <div class="format-text">
                                        <label>Biaya yang dikenakan setiap pelaksanaan transaksi</label> :
                                        <span>Bervariasi sesuai dengan jenis kontrak perdagangan</span>
                                    </div>
                                    <div class="penutup">
                                        <div class="content-penutup">
                                            Dengan mengisi kolom “YA” di bawah ini, saya menyatakan bahwa saya telah membaca tentang
                                            <span>PERATURAN PERDAGANGAN (TRADING RULES)</span>, mengerti dan menerima ketentuan dalam bertransaksi
                                        </div>
                                        <div class="pernyataan">
                                            <div class="label">Pernyataan menerima/tidak</div>
                                            <div>
                                                <input
                                                    type="radio"
                                                    name="radiosJfx"
                                                    id="1"
                                                    :value="true"
                                                    v-model="statementTradingJfx"
                                                    required
                                                    @click="(openModal = true), (modalTradingRules = 'jfx')"
                                                /><label class="label-radio" for="">Ya</label>

                                                <input type="radio" name="radiosJfx" id="2" :value="false" v-model="statementTradingJfx" /><label
                                                    class="label-radio"
                                                    for=""
                                                    >Tidak</label
                                                >
                                            </div>
                                        </div>
                                        <div class="pernyataan">
                                            <div class="label">Menerima Pada Tanggal</div>
                                            <div>
                                                {{ currentDate | formatDateTime }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="self-modal" v-show="openModal">
                                        <div class="content-modal" ref="modal">
                                            <div class="title-modal">
                                                <span class="show-content">PERATURAN PERDAGANGAN (TRADING RULES)</span>
                                                <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="openModal = false">
                                                    <span aria-hidden="true">&times;</span>
                                                </button>
                                            </div>
                                            <div class="body-modal">
                                                <trading-gofx :dataPrint="dataPrint" v-if="modalTradingRules == 'icdx'"></trading-gofx>
                                                <trading-jfx :dataPrint="dataPrint" v-else></trading-jfx>
                                            </div>
                                            <div class="footer-modal">
                                                <div class="btn-primer show-content" @click="openModal = false">Setuju</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="wrap-document">
                        <div class="page">
                            <p class="title">PERNYATAAN BERTANGGUNG JAWAB ATAS KODE AKSES TRANSAKSI NASABAH (<i>Personal Access Password</i>)</p>
                            <div class="content">
                                <p>Yang mengisi formulir di bawah ini:</p>
                                <div class="format-text">
                                    <label>Nama Lengkap</label> : <span>{{ dataPrint.fullname }}</span>
                                </div>
                                <div class="format-text">
                                    <label>Tempat/Tanggal Lahir</label> : <span>{{ dataPrint.tempat_lahir }}, {{ dataPrint.tanggalLahir | formatDate }}</span>
                                </div>
                                <div class="format-text">
                                    <label>Alamat Rumah</label> : <span>{{ dataPrint.alamat }}</span>
                                </div>
                                <div class="format-text">
                                    <label>Kode Pos</label> : <span>{{ identityAddress.postcode }}</span>
                                </div>
                                <div class="format-text">
                                    <label>Nomor Identitas (KTP/SIM/PASSPOR)</label> : <span>{{ dataPrint.ktp }}</span>
                                </div>
                                <div class="format-text">
                                    <label> No ACC *<small>(muncul setelah pendaftaran disetujui)</small> </label>
                                    : <span>.......................</span>
                                </div>
                                <p>
                                    Dengan mengisi kolom “YA” di bawah ini, saya menyatakan bahwa saya bertanggungjawab sepenuhnya terhadap kode akses transaksi
                                    Nasabah (Personal Access Password) dan tidak menyerahkan kode akses transaksi Nasabah (Personal Access Password) ke pihak lain,
                                    terutama kepada pegawai Pialang Berjangka atau pihak yang memiliki kepentingan dengan Pialang Berjangka.
                                </p>
                                <div class="wraning text-center mb-3">
                                    <p>PERINGATAN !!!</p>
                                    Pialang Berjangka, Wakil Pialang Berjangka, pegawai Pialang Berjangka, atau pihak yang memiliki kepentingan dengan Pialang
                                    Berjangka dilarang menerima kode akses transaksi Nasabah (Personal Access Pasword).
                                </div>
                                <div class="penutup">
                                    <p>
                                        Demikian Pernyataan ini dibuat dengan sebenarnya dalam keadaan sadar, sehat jasmani dan rohani serta tanpa paksaan apapun
                                        dari pihak manapun.
                                    </p>
                                    <div class="pernyataan">
                                        <div class="label">Pernyataan menerima/tidak</div>
                                        <div class="input">
                                            <input type="radio" name="radio" id="1" :value="true" v-model="statementCode" required /><label
                                                class="label-radio"
                                                for=""
                                                >Ya</label
                                            >

                                            <input type="radio" name="radio" id="2" :value="false" v-model="statementCode" /><label class="label-radio" for=""
                                                >Tidak</label
                                            >
                                        </div>
                                    </div>
                                    <div class="pernyataan">
                                        <div class="label">Menerima Pada Tanggal</div>
                                        <div>
                                            {{ currentDate | formatDateTime }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="wrap-document">
                        <div class="page">
                            <p class="title">PERNYATAAN NASABAH</p>
                            <div class="content">
                                Dengan ini menyatakan bahwa dana yang dipergunakan untuk bertransaksi adalah milik saya sendiri dan bukan dana pihak lain, serta
                                tidak diperoleh dari hasil penipuan, penggelapan, hasil pencucian uang maupun tindak pidana korupsi dan perbuatan melawan hukum
                                lainnya serta tidak dimaksudkan untuk melakukan pencucian uang;
                            </div>
                        </div>
                    </div>

                    <p class="error text-center">{{ message }}</p>
                    <div class="button">
                        <router-link to="/amanat"><button class="btn-scondary">Sebelumnya</button></router-link>
                        <!-- <router-link to="/register-preview"> -->
                        <button class="btn-primer" type="submit" @click="CheckStatement">
                            <div>Selanjutnya</div>
                        </button>
                        <!-- </router-link> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import HeadRegister from "./component/HeadRegister.vue";
import axios from "axios";
import TradingGofx from "../assets/filedownload/TradingGofx.vue";
import TradingJfx from "../assets/filedownload/TradingJfx.vue";
export default {
    components: {
        HeadRegister,
        TradingGofx,
        TradingJfx,
    },
    data() {
        return {
            currentDate: "",
            openModal: false,
            statementTrading: false,
            statementCode: false,
            statementTradingJfx: false,
            modalTradingRules: "",
            dataPlatform: "",
            message: "",
            identityAddress: "",
            idCustomer: "",
            form: {
                has_set_trading_simulation: "",
                has_confirm_costumer: "",
                has_investment_experience: "",
                has_set_company_profile: "",
                has_set_investment_experience: "",
                has_set_mandate: "",
                has_set_risk: "",
                has_set_trading_rules: "",
                step: "codeAccess",
                completeness_verification: "",
                disclosure_customer: "",
                disclosure_risk: "",
                disclosure_mandate: "",
            },
            dataPrint: {
                fullname: "",
                alamat: "",
                telepone: "",
                ktp: "",
                pekerjaan: "",
                tandaTangan: null,
                noKantor: "",
                company_id: "",
                namaPejabat: "",
                jabatan: "",
                jabatanNasabah: "",
                no_ac_demo: "",
                tempat_ttd: "",
                complement: "",
                tanggalLahir: "",
                tempat_lahir: "",
                platform: [],
            },
        };
    },
    methods: {
        CheckStatement() {
            if (this.statementCode == true && (this.statementTrading == true || this.statementTradingJfx == true)) {
                this.form.has_set_trading_rules = true;
                let methode;
                if (this.idCustomer) {
                    methode = {
                        url: "/v2/kyc/customer/" + this.idCustomer,
                        method: "PUT",
                        data: this.form,
                    };
                } else {
                    methode = {
                        url: "/v2/kyc/customer",
                        method: "POST",
                        data: this.form,
                    };
                }
                if (this.form.has_set_trading_rules) {
                    axios(methode)
                        .then((res) => {
                            let status = res.data.data.status_code;
                            if (status == "00") {
                                this.isLoading = false;
                                this.$router.push("/register-preview");
                            }
                        })
                        .catch((error) => {
                            this.isLoading = false;
                            console.log(error);
                            this.$notify({
                                group: "foo",
                                title: "Cek kembali inputan anda",
                                type: "error",
                                duration: 2000,
                            });
                        });
                }
            } else {
                this.$toast.error("Statement Menerima belum disetujui");
                this.isLoading = false;
                // this.message = "Mohon untuk menyutujui pernyataan ya / tidak";
            }
        },
    },
    mounted() {
        axios.get("/v2/user/profile").then((res) => {
            this.dataPrint.platform = res.data.data.user.platform;
            this.dataPlatform = this.dataPrint.platform;

            // this.dataPlatform = this.dataPrint.platform.reduce((a, v) => ({ javet: a, mt5: v }));
        });
        this.currentDate = new Date();
        this.$store.dispatch("getCustomer").then((res) => {
            this.form.has_set_investment_experience = res.has_set_investment_experience;
            this.form.has_set_trading_simulation = res.has_set_trading_simulation;
            this.form.has_confirm_costumer = res.has_confirm_costumer;
            this.form.has_set_company_profile = res.has_set_company_profile;
            this.form.has_set_mandate = res.has_set_mandate;
            this.form.has_set_risk = res.has_set_risk;
            this.form.has_set_trading_rules = res.has_set_trading_rules;
            this.form.completeness_verification = res.completeness_verification;
            this.form.disclosure_customer = res.disclosure_customer;
            this.form.disclosure_risk = res.disclosure_risk;
            this.form.disclosure_mandate = res.disclosure_mandate;
            if (this.form.has_set_trading_rules) {
                this.statementCode = true;
                this.statementTrading = true;
                this.statementTradingJfx = true;
            }
            this.idCustomer = res._id;
            let dataAddress = res.identity_address;
            this.identityAddress = dataAddress;
            this.dataPrint.fullname = res.fullname;
            this.dataPrint.ktp = res.ktp_no;
            this.dataPrint.telepone = res.phonenumber;
            this.dataPrint.tempat_ttd = res.identity_address.regency;
            this.dataPrint.tanggalLahir = res.date_of_birth;
            this.dataPrint.tempat_lahir = res.place_of_birth;
            this.dataPrint.alamat =
                dataAddress.address + ", Kel. " + dataAddress.village + ", Kec. " + dataAddress.district + " " + dataAddress.regency + " " + dataAddress.province;

            axios.get("/v2/kyc/employment/" + res._id).then((resEmploy) => {
                this.dataPrint.pekerjaan = resEmploy.data.data.employment.occupation_type.name;
                this.dataPrint.jabatanNasabah = resEmploy.data.data.employment.other_position;
                this.dataPrint.noKantor = resEmploy.data.data.employment.company_address.telephone;
            });

            axios.get("/v2/kyc/attachment/" + res._id).then((resAttac) => {
                let attachment = resAttac.data.data.attachment;
                this.$store.dispatch("getImageAccess", attachment.signature).then((resImg) => {
                    this.dataPrint.tandaTangan = resImg;
                });
            });
        });
    },
};
</script>

<style scoped>
label {
    width: 12rem;
}

.container-outline {
    width: 70%;
}

.content-register {
    box-shadow: 0 0 2rem 0 rgba(136, 152, 170, 0.15);
    background: #ffffff;
    border-radius: 5px;
}

.button {
    display: flex;
    justify-content: space-between;
    padding: 76px 63px;
}

.register {
    margin: 46px 0;
}

.container {
    width: 100%;
}

.page {
    padding: 1cm;
    /* border: 5px red solid; */
    height: 257mm;
    /* outline: 2cm #FFFFFF solid; */
}

.format-text {
    text-transform: capitalize;
    display: flex;
    gap: 1rem;
}

.format-text span {
    width: 70%;
}

.footer-modal .btn-primer {
    margin: 0 auto;
}

.format-text::first-letter,
.format-text::first-line {
    text-transform: capitalize;
}

.wrap-document {
    /* width: 210mm; */
    min-height: 297mm;
    padding: 10mm;
    margin: 0 auto;
    /* border: 1px #D3D3D3 solid; */
    border-radius: 5px;
    background: white;
    /* box-shadow: 0 0 5px rgba(0, 0, 0, 0.1); */
    position: relative;
}

.tanda-tangan {
    width: 100%;
}

.top {
    display: flex;
    justify-content: space-between;
    font-size: 10px;
}

.header {
    display: flex;
    justify-content: space-between;
    font-size: 10px;
    margin-bottom: 25px;
}

.nomor {
    font-weight: bold;
}

.lampiran p {
    margin: 0;
    text-align: right;
}

.title {
    font-weight: bold;
    text-align: center;
    margin: 0 auto 40px;
    font-size: 14px;
}

.title-page {
    font-size: 25px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    margin: 0 0 50px;
}

.content {
    font-size: 14px;
}

.label-radio {
    width: 3rem;
    margin-left: 0.6rem;
}

.sub-content {
    font-weight: 700;
}

/* 
form {
  margin: 20px 0;
  text-align: right;
  font-weight: 700;
} */

.penutup {
    font-weight: normal;
    font-size: 14px;
    margin-bottom: 2rem;
}

.content-penutup {
    width: 80%;
    text-align: center;
    margin: 1rem auto;
}

.title-penutup {
    font-weight: bold;
    font-size: 16px;
    text-align: center;
}

.pernyataan {
    display: flex;
    padding: 0 1rem;
    margin-top: 1rem;
    gap: 1rem;
}

.pernyataan:last-child {
    margin-top: unset;
}

.label {
    width: 20rem;
}
.resiko {
    font-weight: 700;
}

.persetujuan {
    /* width: 60%; */
    font-size: 12px;
    display: flex;
    justify-content: flex-end;
}

.wrap-signature {
    text-align: center;
    width: 30%;
}

.footer {
    display: flex;
    font-size: 10px;
    justify-content: space-between;
    position: absolute;
    width: 80%;
    bottom: 0;
}

@page {
    size: A4;
    margin: 0;
}

@media (max-width: 768px) {
    .page {
        padding: 0;
    }

    .title {
        margin: 20px auto !important;
    }
    .container-outline {
        width: 90%;
    }

    li > span {
        display: none;
    }

    .form-input,
    select,
    .input-button {
        width: 100%;
    }

    .birtday,
    .kecamatan,
    .input-rt-rw {
        width: 100% !important;
        text-align: left;
    }

    .register {
        margin: 20px 0;
    }

    .title {
        font-size: 18px;
        margin: 0 0 20px;
    }

    .sub-title {
        margin-bottom: 20px;
    }

    .top-squence {
        width: 100%;
        padding: 15px 10px;
    }

    .container {
        width: 100%;
        padding: 25px 20px;
    }

    .identitas,
    .form-ktp-bagi,
    .tanggal-aktif,
    .tempat,
    .kecamatan,
    .input-rt-rw {
        margin: 0 0 10px;
    }

    .detail-alamat,
    .rt-rw {
        margin: 0 0 0.5rem;
    }

    .form-checkbox {
        align-items: flex-start;
    }

    .label--checkbox {
        position: inherit !important;
        margin-left: 15px;
    }

    label {
        display: block;
    }

    .button {
        display: block;
        width: 100%;
        padding: 25px 20px;
        text-align: center;
    }

    .btn-scondary,
    .btn-primer {
        width: 100%;
    }

    .btn-scondary {
        margin-bottom: 20px;
    }

    .content-modal {
        width: 95%;
    }

    .wrap-document {
        width: 100%;
        padding: 30px 0;
    }

    .group-file {
        display: block;
    }

    .wrap-label {
        width: 100%;
    }

    .picture {
        margin-bottom: 55px;
    }

    .video {
        height: 100%;
        object-fit: contain;
    }

    .feed {
        width: 80%;
        height: 100%;
        object-fit: cover;
        margin: auto;
    }
    .pernyataan .label {
        width: 10rem;
    }

    .pernyataan .input {
        display: flex;
        align-items: baseline;
    }
}
</style>
